export const styles = {
  picturesWraper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  avatarWraper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px'
  },
  picture: {
    width: 300,
    height: 300,
    marginBottom: '16px'
  }
}
